<template>
  <transition name="info-popup-fade" @before-enter="beforeEnter">
    <div class="info-popup-backdrop" @click.self="close">
      <div class="info-popup">
        <div class="info-popup-title ">{{ text }}</div>
        <div class="icon-info-popup" v-if="icon">
          <v-icon
            :color="colorIcon"
          >
            {{ icon }}
          </v-icon>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>

import { mapGetters } from 'vuex';

export default {
  name: 'info-popup-block',
  props: {
    text: { type: String, required: true, },
    icon: { type: String },
    colorIcon: { type: String }
  },
  computed: {
    ...mapGetters(['selectedLanguage'])
  },
  methods: {
    close() {
      this.$emit('close');
    },
    beforeEnter() {
      return 'ok';
    },
  },
};
</script>

<style scoped>
.info-popup-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
}

.info-popup {
  background-color: #ffffff;
  box-shadow: rgba(0, 0, 0, 0.29) 5px 5px 25px 0;
  border-radius: 25px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  width: 85%;
  max-width: 450px;
  height: fit-content;
  padding: 20px 20px 30px 20px;
}

.info-popup-title {
  text-align: center;
  color: black;
  font-weight: bold;
}

.icon-info-popup {
  text-align: center;
}
</style>
